var _clipPath, _polygon, _line, _line2, _line3, _line4, _line5, _polygon2, _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 60",
    width: 280,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldG",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F0D080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#C5A059"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#9A7535"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldText",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#E8C96A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#C5A059"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "tc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30,4 56,50 4,50"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "30,4 56,50 4,50",
    fill: "url(#goldG)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 26,
    x2: 56,
    y2: 26,
    stroke: "#0B1629",
    strokeWidth: 1.2,
    clipPath: "url(#tc)",
    opacity: 0.65
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 38,
    x2: 56,
    y2: 38,
    stroke: "#0B1629",
    strokeWidth: 1.2,
    clipPath: "url(#tc)",
    opacity: 0.65
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 50,
    stroke: "#0B1629",
    strokeWidth: 1.3,
    clipPath: "url(#tc)",
    opacity: 0.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 10,
    y2: 50,
    stroke: "#0B1629",
    strokeWidth: 1.1,
    clipPath: "url(#tc)",
    opacity: 0.55
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 4,
    x2: 50,
    y2: 50,
    stroke: "#0B1629",
    strokeWidth: 1.1,
    clipPath: "url(#tc)",
    opacity: 0.55
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "12,46 17,46 20,32 25,42 30,18 35,42 40,32 43,46 48,46 30,10",
    fill: "#0B1629",
    opacity: 0.88
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 52,
    width: 52,
    height: 2,
    fill: "url(#goldG)",
    rx: 1,
    opacity: 0.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 30,
    fontFamily: "'Outfit', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#FFFFFF",
    letterSpacing: 0.5
  }, "MA ", /*#__PURE__*/React.createElement("tspan", {
    fill: "url(#goldText)"
  }, "Galaxy"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 69,
    y: 46,
    fontFamily: "'Manrope', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 8,
    fontWeight: 400,
    fill: "#C5A059",
    letterSpacing: 3.5,
    opacity: 0.85
  }, "INTERNATIONAL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e321e7837a658a372c124147364de13.svg";
export { ForwardRef as ReactComponent };